import { DecimalPipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { IColumnsDataTable } from '../../Entities/entities';
import { typeTheme } from '../../Entities/table.entities';
import { PipeEnum, paginatorConfig } from '../../helpers/constants';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.sass'],
})
export class TableComponent implements OnInit, OnChanges {
  @Input() displayedColumns: IColumnsDataTable[] = [];
  @Input() customHeight = '480px';
  @Input() scrollRow = 10;
  @Input() visiblePaginator = false;
  @Input() datasource: any[] = [];
  @Output() $onChangeCheckboxItem = new EventEmitter();
  pipe = PipeEnum;
  @Input() customHeader = '';
  @Input() hasFooter = false;
  @Input() theme = typeTheme.dark;
  @Input() class: string;
  @Input() message = '';
  @Input() paginatorLength = 0;
  @Input() showHeader = true;
  @Input() isApvSelect: boolean;
  checkedAll = false;
  @Output() iconClick$ = new EventEmitter();
  @Output() paginatorEvent$ = new EventEmitter();
  hasRowCheckBox: boolean;
  showUF2: boolean = true;
  displayedColumnsLabel: string[] = this.displayedColumns.map(m => m.ColumnDef);
  pageSize = paginatorConfig.pageSize;
  pageSizeOptions: number[] = paginatorConfig.pageSizeOptions;
  constructor() {
    // this.showHeader = true;
  }

  ngOnInit() {
    this.setAllChecked();
    this.validateUF();
  }

  trackByIndex = i => i;

  setAllChecked() {
    if (this.hasRowCheckBox) {
      if (this.datasource.every(item => item.Checked)) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setAllChecked();
    const currentItem: SimpleChange = changes.displayedColumns;
    if (!currentItem) {
      return;
    }

    this.displayedColumnsLabel = currentItem.currentValue.map(m => m.ColumnDef);
    this.hasRowCheckBox = currentItem.currentValue.find(x => x.CheckBox)
      ? true
      : false;
  }

  onIconClick(item, icon) {
    const i = {
      item,
      icon,
    };
    this.iconClick$.emit(i);
  }

  validateUF(){
    for (let x of this.datasource) {
      if (x.GlosaLarga === 'UF + 2% ANUAL') {
        this.showUF2 = false;
      }else{
        this.showUF2 = true;
      }
    }
  }

  getTotalCost(column: IColumnsDataTable) {
    let value = '';
    if (!column) {
      return '';
    }

    if (!column.Sum) {
      return '';
    }

    const sum = column.Sum;

    switch (column.Pipe) {
      case PipeEnum.currencyCLPipe:
        if (!sum) {
          value = '$ 0';
          return;
        }
        value = `$ ${new DecimalPipe('es-CL').transform(sum)}`;
        break;
      case PipeEnum.thousandPipe:
        if (!sum) {
          value = '0';
          return;
        }
        value = `${new DecimalPipe('es-CL').transform(sum)}`;
        break;
      case PipeEnum.UFPipe:
        if (!sum) {
          value = '0';
          return;
        }
        value = `${new DecimalPipe('es-CL').transform(sum, '1.2-4')}`;
        break;
      case PipeEnum.decimalPipe:
        if (!sum) {
          value = '0';
          return;
        }
        value = `${new DecimalPipe('es-CL').transform(sum)}`;
        break;
      case PipeEnum.percentagePipe:
        value = `${new DecimalPipe('es-CL').transform(sum * 100)} %`;
        break;
      case PipeEnum.purePercentagePipe:
        value = `${new DecimalPipe('es-CL').transform(sum)} %`;
        break;
      default:
        value = sum.toString();
        break;
    }
    return value;
  }

  onChangeCheckboxItem(event, element) {
    element.Checked = event.checked;

    if (!event.checked) {
      this.checkedAll = false;
    }
  }

  onChangeCheckboxAll(event) {
    this.datasource.forEach(x => (x.Checked = event.checked));
  }

  getDataPaginator(event) {
    this.paginatorEvent$.emit(event);
  }
}
